import * as React from 'react'

export interface ITranslationPresentationProps {
    translations: { [key:string]: string }
    tag: string
}

const TranslationPresentation = ( props: ITranslationPresentationProps ) => <span>{props.translations[props.tag]!=undefined?props.translations[props.tag]:props.tag}</span>

export default TranslationPresentation;
